var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{staticClass:"is-sticky"}),_c('div',{staticClass:"container radix-nav pricing-nav pt-3 pb-3"},[_c('PricingSection')],1),_c('FooterMain',{staticClass:"radix-nav",attrs:{"FooterStyle":"bg_drak-footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }